import { AUTH_EXPIRED_FLASH_MESSAGE_KEY } from '../constants';

export function consumeAuthExpiredFlashMessage(): string | null {
  try {
    const raw = sessionStorage.getItem(AUTH_EXPIRED_FLASH_MESSAGE_KEY);
    if (raw) {
      sessionStorage.removeItem(AUTH_EXPIRED_FLASH_MESSAGE_KEY);
      return raw;
    }
    return null;
  } catch {
    return null;
  }
}
